import { createSlice } from "@reduxjs/toolkit";
import {
  fetchParticipants,
  addParticipant,
  updateParticipant,
  withdrawParticipantThunk,
} from "./tournamentParticipants.thunk";

const initialState = {
  participants: [],
  summary: { total_registered: 0, active_count: 0, withdrawn_count: 0, absent_count: 0 },
  meta: {
    total: 0,
    total_pages: 1,
    page: 1,
    limit: 10,
  },
  loading: false,
  error: null,
  selectedParticipant: null,
};

const tournamentParticipantsSlice = createSlice({
  name: "tournamentParticipants",
  initialState,

  reducers: {
    setSelectedParticipant: (state, action) => {
      state.selectedParticipant = action.payload;
    },
    clearSelectedParticipant: (state) => {
      state.selectedParticipant = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ================= FETCH ================= */
      .addCase(fetchParticipants.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchParticipants.fulfilled, (state, action) => {
        state.loading = false;

        const payload = action.payload;
        
        // Handle participants array
        let participants = [];
        if (Array.isArray(payload?.data)) {
          participants = payload.data;
        } else if (Array.isArray(payload?.data?.data)) {
          participants = payload.data.data;
        }
        state.participants = participants;

        // Store Summary from API
        state.summary = payload?.summary || { 
            total_registered: 0, active_count: 0, withdrawn_count: 0, absent_count: 0 
        };

        // Safe meta fallback
        state.meta = payload?.meta || {
          total: participants.length,
          total_pages: 1,
          page: 1,
          limit: 10,
        };
      })

      .addCase(fetchParticipants.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch participants";
      })

      /* ================= ADD ================= */
      .addCase(addParticipant.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(addParticipant.rejected, (state, action) => {
        state.error = action.payload;
      })

      /* ================= UPDATE ================= */
      .addCase(updateParticipant.fulfilled, (state, action) => {
        const updated = action.payload?.data;
        if (!updated || !updated.id) return;

        const index = state.participants.findIndex((p) => p.id === updated.id);
        if (index !== -1) {
          state.participants[index] = { ...state.participants[index], ...updated };
        }
      })

      .addCase(updateParticipant.rejected, (state, action) => {
        state.error = action.payload;
      })

      /* ================= WITHDRAW / ABSENT ================= */
      .addCase(withdrawParticipantThunk.fulfilled, (state, action) => {
        // Instead of filtering out, we update the status in the existing list
        const metaPayload = action.meta?.arg;
        if (metaPayload?.id) {
          const index = state.participants.findIndex((p) => p.id === metaPayload.id);
          if (index !== -1) {
            state.participants[index] = {
              ...state.participants[index],
              status: metaPayload.status,
              status_reason: metaPayload.reason
            };
          }
        }
      })

      .addCase(withdrawParticipantThunk.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const {
  setSelectedParticipant,
  clearSelectedParticipant,
} = tournamentParticipantsSlice.actions;

export default tournamentParticipantsSlice.reducer;